<template>
  <div class="case-creation__step case-creation__billing-information">
    <el-row>
      <el-col :span="24">
        <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-billing-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Billing Information</h3>
            </div>
          </div>
          <div class="case-creation__body bill pt-5">
            <div class="case-creation__tabs billing-information-tabs">
              <el-tabs v-model="activeName">
                <el-tab-pane label="PRIMARY INSURANCE" name="first">
                  <div id="primary-insurance" v-if="activeName === 'first'">
                    <div class="primary-insurance-view">
                      <div class="step-inner-navbar"></div>

                      <div class="step-inner-content">
                        <div class="vue-form">
                          <el-form>
                            <el-row :gutter="25">
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Relationship</h4>
                                  <p class="value" v-if="getBillingInformation">
                                    {{ getBillingInformation.relationship }}
                                  </p>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Plan Type</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.plan_type
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">First Name</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.primary_insurance
                                          .first_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Middle Name</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.primary_insurance
                                          .middle_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Last Name</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.primary_insurance.last_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Gender</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.gender
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Date of Birth</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      formatDate(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.primary_insurance
                                          .date_of_birth
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Name</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.payor
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Carrier Code</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance
                                        .insurance_carrier_code
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Policy No</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.policy_id
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Group#</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.group
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 1</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance
                                        .address_line_1
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 2</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance
                                        .address_line_2
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Zip</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.zip
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">State</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.state
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">City</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.primary_insurance.city
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                            </el-row>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="SECONDARY INSURANCE" name="second">
                  <div id="secondary-insurance" v-if="activeName === 'second'">
                    <div class="secondary-insurance-view">
                      <div class="step-inner-navbar"></div>

                      <div class="step-inner-content">
                        <div class="vue-form">
                          <el-form>
                            <el-row :gutter="25">
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Relationship</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance
                                        .relationship
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Plan Type</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.plan_type
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">First Name</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.secondary_insurance
                                          .first_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Middle Name</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.secondary_insurance
                                          .middle_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Last Name</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.secondary_insurance
                                          .last_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Gender</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.gender
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Date of Birth</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      formatDate(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.secondary_insurance
                                          .date_of_birth
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Name</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.payor
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Carrier Code</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance
                                        .insurance_carrier_code
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Policy No</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.policy_id
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Group#</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.group
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 1</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance
                                        .address_line_1
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 2</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance
                                        .address_line_2
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Zip</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.zip
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">State</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.state
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">City</h4>
                                  <span
                                    class="value"
                                    v-if="getSecondaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.secondary_insurance.city
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                            </el-row>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="TERTIARY INSURANCE" name="third">
                  <div id="tertiary-insurance" v-if="activeName === 'third'">
                    <div class="tertiary-insurance-view">
                      <div class="step-inner-navbar"></div>

                      <div class="step-inner-content">
                        <div class="vue-form">
                          <el-form>
                            <el-row :gutter="25">
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Relationship</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance
                                        .relationship
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Plan Type</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.plan_type
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">First Name</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.tertiary_insurance
                                          .first_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Middle Name</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.tertiary_insurance
                                          .middle_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Last Name</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      convertToUppercase(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.tertiary_insurance
                                          .last_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Gender</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.gender
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Date of Birth</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      formatDate(
                                        getSinglePhlebioDetails.billing_info
                                          .insurance.tertiary_insurance
                                          .date_of_birth
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Name</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.payor
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Carrier Code</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance
                                        .insurance_carrier_code
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Policy No</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.policy_id
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Group#</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.group
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 1</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance
                                        .address_line_1
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 2</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance
                                        .address_line_2
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Zip</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.zip
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">State</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.state
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">City</h4>
                                  <span
                                    class="value"
                                    v-if="getTertiaryInsurance"
                                  >
                                    {{
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.tertiary_insurance.city
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                            </el-row>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="GUARANTOR INSURANCE" name="fourth">
                  <div id="guarantorForm-view" v-if="activeName === 'fourth'">
                    <div class="step-inner-navbar"></div>

                    <div class="step-inner-content">
                      <div class="vue-form">
                        <el-form>
                          <el-row :gutter="25">
                            <el-col :xl="4" :lg="3" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Relationship</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getSinglePhlebioDetails.billing_info
                                      .insurance.guarantor.relationship
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>

                            <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">First Name</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    convertToUppercase(
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.guarantor.first_name
                                    )
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Middle Name</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    convertToUppercase(
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.guarantor.middle_name
                                    )
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Last Name</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    convertToUppercase(
                                      getSinglePhlebioDetails.billing_info
                                        .insurance.guarantor.last_name
                                    )
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="3" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Gender</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getSinglePhlebioDetails.billing_info
                                      .insurance.guarantor.gender
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>

                            <el-col :xl="4" :lg="6" :md="4" :sm="10" :xs="10">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Address Line 1</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getSinglePhlebioDetails.billing_info
                                      .insurance.guarantor.address_line_1
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="7" :md="4" :sm="10" :xs="10">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Address Line 2</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getSinglePhlebioDetails.billing_info
                                      .insurance.guarantor.address_line_2
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="4" :md="4" :sm="8" :xs="8">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Zip</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getSinglePhlebioDetails.billing_info
                                      .insurance.guarantor.zip
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>

                            <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">State</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getSinglePhlebioDetails.billing_info
                                      .insurance.guarantor.state
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">City</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getSinglePhlebioDetails.billing_info
                                      .insurance.guarantor.city
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                          </el-row>
                        </el-form>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <ResonForChange
    v-if="takeReasonDialog"
    v-on:close="takeReasonDialog = false"
    v-on:reasonSubmit="deleteBillingInfo"
    title="Reason for Remove Billing Info"
  ></ResonForChange>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
export default {
  mixins: [UserPermissionsHelper],
  components: {
    ResonForChange,
  },
  data() {
    return {
      activeName: "first",
      loading: false,
      takeReasonDialog: false,
    };
  },
  computed: {
    ...mapGetters("phlebio", ["getSinglePhlebioDetails"]),
    getBillingInformation() {
      if (
        this.getSinglePhlebioDetails &&
        Object.keys(this.getSinglePhlebioDetails).length > 0 &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance
      ) {
        return this.getSinglePhlebioDetails.billing_info.insurance
          .primary_insurance;
      }
      return null;
    },
    getSecondaryInsurance() {
      if (
        this.getSinglePhlebioDetails &&
        Object.keys(this.getSinglePhlebioDetails).length > 0 &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance
      ) {
        return this.getSinglePhlebioDetails.billing_info.insurance
          .secondary_insurance;
      }
      return null;
    },
    getTertiaryInsurance() {
      if (
        this.getSinglePhlebioDetails &&
        Object.keys(this.getSinglePhlebioDetails).length > 0 &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance
      ) {
        return this.getSinglePhlebioDetails.billing_info.insurance
          .tertiary_insurance;
      }
      return null;
    },
    getGuarantor() {
      if (
        this.getSinglePhlebioDetails &&
        Object.keys(this.getSinglePhlebioDetails).length > 0 &&
        this.getSinglePhlebioDetails.billing_info &&
        this.getSinglePhlebioDetails.billing_info.insurance
      ) {
        return this.getSinglePhlebioDetails.billing_info.insurance.guarantor;
      }
      return null;
    },
  },
  methods: {
    deleteReason() {
      this.takeReasonDialog = true;
    },
    goToEditForm() {
      this.$router.push({
        name: "Edit-Order-Info",
        params: { order_id: this.$route.params.order_id },
        query: this.$route.query,
      });
    },
    async deleteBillingInfo() {
      this.order_id = this.$route.params.order_id;
      try {
        this.loading = true;
        await this.$store.dispatch("orders/deleteBillingInfo", this.order_id);
        if (this.getDeleteOrderBillingInfoStatus) {
          successNotification(
            "Billing Information details cleared successfully"
          );
          window.location.reload();
        } else {
          if (!this.getDeleteOrderBillingInfoStatus) {
            errorNotification("Error in clearing Billing Information details");
          }
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
.case-creation__billing-information {
  .case-creation__body {
    padding: 0;
  }
  .el-tabs__content {
    padding: 0 20px;
  }
  .el-tabs__nav-scroll {
    padding: 0 20px;
  }
  .el-tabs__nav-wrap::after {
    height: 1px;
  }
  .right-align {
    display: flex;
  }
  .delete-billing-info {
    margin-right: 20px;
    padding: 5px 0;

    button {
      background: #f24a55;
      min-height: 25px;
      border: none;

      padding: 5px 20px;
    }
  }
}
</style>
